import { Route } from "@angular/router";
import { PersonalInformationComponent } from "./personal-information.component";

export const PersonalInformationRouting: Route = {
    path: 'personal-information',
    component: PersonalInformationComponent,
    data: {
        breadcrumb: "Informations Personnelles"
    }
}
